import PostItem from 'components/Pages/Blog/PostItem';
import styles from './RecentStories.module.scss';
import type { BlogItem } from 'types/Blog';
import type { RecentStoriesItem } from 'types/PageData';

type Props = {
  entries?: RecentStoriesItem[];
  headline?: string;
};

const RecentStories = ({ entries, headline }: Props): JSX.Element | null => {
  if (!entries?.length) {
    return null;
  }

  return (
    <div className="max-w-screen-xl mx-auto mb-24">
      {headline && (
        <h2 className="text-2-188r lg:text-1-938r px-5 lg:px-4">{headline}</h2>
      )}
      <div className="px-3 lg:px-4">
        <ul id="posts-container" className={styles.list}>
          {entries?.filter(Boolean).map((item, i) => {
            return (
              <li key={i} className={styles.item}>
                <PostItem fields={item as BlogItem} />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default RecentStories;
